"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Elevation = void 0;
exports.Elevation = {
    "shadow-none": "none",
    "shadow-100": "1px 2px 2px 0px rgba(0, 0, 0, 0.10)",
    "shadow-200": "1px 4px 4px 0px rgba(0, 0, 0, 0.10)",
    "shadow-300": "1px 8px 8px 0px rgba(0, 0, 0, 0.10)",
    "shadow-400": "1px 16px 16px 0px rgba(0, 0, 0, 0.10)",
    "shadow-500": "0px 24px 24px 0px rgba(0, 0, 0, 0.10)",
    "shadow-inset": "0px 4px 4px 0px rgba(0, 0, 0, 0.10) inset"
};
//# sourceMappingURL=Elevation.js.map